import { i18n } from 'i18next';
import { CustomTypeOptions } from 'react-i18next';
export function registerResetPasswordFormResourceBundleEn(i18next: i18n): void {
  i18next.addResourceBundle('en', 'record-it-components', {
    form: {
      ResetPasswordForm: {
        cancel: 'Cancel',
        noPasswordEnteredText: 'No password was entered.',
        passwordLabel: 'New password',
        resettingPasswordFailedText: 'A problem while resetting your password occurred.',
        resetPassword: 'Reset password',
        successNotification: {
          title: 'Sucessfully reset your password',
          message: 'You can now log in with your new password.'
        },
        title: 'Reset password'
      }
    }
  } as Partial<CustomTypeOptions['resources']['record-it-components']>, true);
}